import { render } from "./ProductItem.vue?vue&type=template&id=abaf1a36&scoped=true&ts=true"
import script from "./ProductItem.vue?vue&type=script&lang=ts"
export * from "./ProductItem.vue?vue&type=script&lang=ts"

import "./ProductItem.vue?vue&type=style&index=0&id=abaf1a36&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abaf1a36"]])

export default __exports__